import { mapActions } from "vuex";
import notifyMessages from "./notifyMessages";

export default {
  mixins: [ notifyMessages ],

  computed: {
    target() { return this.item || this.model },
    clonedSearch() { return this.$store.state.booleanSearch.clonedSearch },
    cloningError() { return this.$store.state.booleanSearch.clonedError },
    isCloned() {  return this.clonedSearch && this.target.id === this.clonedSearch.id }
  },

  methods: {
    ...mapActions({
      cloneResource: 'booleanSearch/cloneResource',
    }),

    cloneToggle() {
      this.$store.commit('booleanSearch/SET_CLONED_SEARCH', this.target)
      this.clearCloneError();
    },

    resetCloneToggle() {
      this.$store.commit('booleanSearch/SET_CLONED_SEARCH', null)
      this.clearCloneError();
    },

    clearCloneError() {
      this.$store.commit('booleanSearch/SET_CLONING_ERROR', false);
    },

    execCloneResource(name, searchId, cloneToId, key) {
      this.cloneResource({name, searchId, cloneToId, key})
        .then(() => { if(!this.cloningError) this.notifyStoreSuccess(this.$t('booleanSearch.cloned_success_message')) })
        .catch(() => this.notifyStoreError(this.$t('booleanSearch.cloned_error_message')))
        .finally(() => { if(!this.cloningError) this.resetCloneToggle() })
    },
  }
}